import { apiSchematicMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const pathsApiRoutes = {
    get: apiSchematicMapBaseURL + "data/paths/",
    getShapes: apiSchematicMapBaseURL + "data/shapes/"
};

export class PathAPI {
    static get(networkEdition, lineIds) {
        const url = `${pathsApiRoutes.get}${networkEdition}/${lineIds}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getShapes(networkEdition, pathIds) {
        const url = `${pathsApiRoutes.getShapes}${networkEdition}/${pathIds}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
